//import "./safetyforms.css";
import { useContext, useState } from "react";
import "react-dropdown/style.css";
import { FaDownload, FaTimes, FaTrash } from "react-icons/fa";
import { useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { deleteDailyReport, exportDailyReportPDF } from "../common/slices/dailyreport";
import { ButtonBase } from "./Buttons";
import { DailyReportAttributes } from "./DailyReportAttributes";
import Divider from "./Divider";
import ModalConfirm from "./ModalConfirm";
import Row from "./Row";
import Sidebar from "./Sidebar";
import { H1 } from "./Typography";
import { ErrorContext } from "../ErrorContext";

const SidebarDailyReport = ({ report }) => {
    const errorContext = useContext(ErrorContext);
    const nav = useNavigate();
    const dispatch = useDispatch();
    const [showDelete, setShowDelete] = useState(false);

    const onDeleteDocument = async () => {
        try {
            await dispatch(deleteDailyReport(report));
            setShowDelete(false);
            nav('/daily-report');
        } catch (ex) {
            errorContext.setError({ errorMessage: "Failed to delete report", forSupport: ex.message })
        }
    }

    const onDownloadClick = async (e) => {
        try {
            e.stopPropagation();
            const url = await dispatch(exportDailyReportPDF({ dailyReportId: report.id }))
            window.open(url, "_blank");
        } catch (ex) {
            errorContext.setError({ errorMessage: "Failed to export report", forSupport: ex.message })
        }
    }

    return (
        <Sidebar>
            <Row>
                <H1 style={{ flex: 1 }}>{report?.type === 'DAILY_REPORT' ? "Daily Report" : "Inspection Report"}</H1>
                <ButtonBase style={{ padding: "0.5rem" }} onClick={() => nav("/daily-report")}>
                    <FaTimes size={"14px"} color="#000" />
                </ButtonBase>
            </Row>
            <Row>
                <ButtonBase style={{ padding: "0.5rem" }} onClick={onDownloadClick} disabled={!report?.pdfKey}>
                    <FaDownload size={"14px"} color="#000" />
                </ButtonBase>
                <Divider.Vertical />
                <ButtonBase style={{ padding: "0.5rem" }} onClick={() => setShowDelete(true)}>
                    <FaTrash size={"14px"} color="#000" />
                </ButtonBase>
            </Row>
            <DailyReportAttributes report={report} />

            {showDelete && <ModalConfirm
                description={`Deleting this daily report will permanently delete it.  This cannot be undone.`}
                title="Confirm Delete"
                onConfirm={onDeleteDocument}
                onClose={() => setShowDelete(false)}
            />}
        </Sidebar>
    )
}

export default SidebarDailyReport;